import * as angular from 'angular';
import 'angular-ui-router';
import permissions from 'application/detail/permissions.json';
import { IntegrationsController } from './IntegrationsController';
import IntegrationsView from './IntegrationsView.html';
import { WebhookController } from './webhook/WebhookController';
import WebhookView from './webhook/WebhookView.html';
import { RdStationController } from './rdstation/RdStationController';
import { RdStationService } from './rdstation/RdStationService';
import RdStationView from './rdstation/RdStationView.html';
import { DashbotController } from './dashbot/DashbotController';
import DashbotView from './dashbot/DashbotView.html';
import { BotanalyticsController } from './botanalytics/BotanalyticsController';
import BotanalyticsView from './botanalytics/BotanalyticsView.html';
import { IntegrationsSegmentService } from './IntegrationsSegmentService';
import { IntegrationsService } from './IntegrationsService';
import { AiAgentService } from 'modules/application/misc/AiAgentService';
import { RdStationCallbackController } from './rdstation/callback/RdStationCallback';
import RdStationCallbackView from './rdstation/callback/RdStationCallback.html';
import { HubspotController } from './hubspot/HubspotController';
import HubspotView from './hubspot/HubspotView.html';
import { OauthFormComponent } from './webhook/components/oauthForm/oauthForm.component';
import { CustomHeadersComponent } from './webhook/components/customHeaders/customHeaders.component';
export default angular
    .module('integrations', ['ui.router'])
    .service('IntegrationsSegmentService', IntegrationsSegmentService)
    .service('IntegrationsService', IntegrationsService)
    .service('RdStationService', RdStationService)
    .component('oauthForm', OauthFormComponent)
    .component('customHeaders', CustomHeadersComponent)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('auth.application.detail.integrations', {
            url: '/integrations',
            views: {
                'content@auth.application.detail': {
                    template: IntegrationsView,
                    controller: IntegrationsController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.payments.claim,
            },
            resolve: {
                checkLayout: AiAgentService.blockAiAgentAccess,
            },
            params: { area: 'payments' },
        })
            .state('auth.application.detail.integrations.webhook', {
            url: '/webhook',
            views: {
                'content@auth.application.detail': {
                    template: WebhookView,
                    controller: WebhookController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state('auth.application.detail.integrations.rdstation', {
            url: '/rdstation',
            views: {
                'content@auth.application.detail': {
                    template: RdStationView,
                    controller: RdStationController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state('rdStationCallback', {
            url: '/rdStationCallback',
            controller: RdStationCallbackController,
            controllerAs: '$ctrl',
            template: RdStationCallbackView,
        })
            .state('auth.application.detail.integrations.dashbot', {
            url: '/dashbot',
            views: {
                'content@auth.application.detail': {
                    template: DashbotView,
                    controller: DashbotController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state('auth.application.detail.integrations.botanalytics', {
            url: '/botanalytics',
            views: {
                'content@auth.application.detail': {
                    template: BotanalyticsView,
                    controller: BotanalyticsController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state('auth.application.detail.integrations.hubspot', {
            url: '/hubspot',
            views: {
                'content@auth.application.detail': {
                    template: HubspotView,
                    controller: HubspotController,
                    controllerAs: '$ctrl',
                },
            },
        });
    }]).name;
